export const SET_PRICE = 'setPrice';
export const STORE_PRICE = 'storePrice';
